// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip-container {
  width: 75vw;
  display: flex;
  column-gap: 16px;
}

.chip-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 250px;
  padding: 10px;
  column-gap: 10px;
  background-color: #0d0d0d;
  border-radius: 5px;
}

.chip-icon {
  height: 28px;
  width: 28px;
  background-color: #262626;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.chip-name {
  font-family: "Karla";
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.chip-value {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .chip-container {
    column-gap: 10px;
  }

  .chip-section {
    height: 40px;
    padding: 8px;
    column-gap: 7px;
    border-radius: 4px;
  }

  .chip-icon {
    height: 22px;
    width: 22px;
  }

  .chip-name {
    font-size: 10px;
    line-height: 16px;
  }

  .chip-value {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/OrderClientDetails/OrderClientDetailsStyle.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".chip-container {\n  width: 75vw;\n  display: flex;\n  column-gap: 16px;\n}\n\n.chip-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  width: 250px;\n  padding: 10px;\n  column-gap: 10px;\n  background-color: #0d0d0d;\n  border-radius: 5px;\n}\n\n.chip-icon {\n  height: 28px;\n  width: 28px;\n  background-color: #262626;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}\n\n.chip-name {\n  font-family: \"Karla\";\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n}\n\n.chip-value {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 16px;\n  white-space: nowrap;\n}\n\n@media (max-width: 1200px) {\n  .chip-container {\n    column-gap: 10px;\n  }\n\n  .chip-section {\n    height: 40px;\n    padding: 8px;\n    column-gap: 7px;\n    border-radius: 4px;\n  }\n\n  .chip-icon {\n    height: 22px;\n    width: 22px;\n  }\n\n  .chip-name {\n    font-size: 10px;\n    line-height: 16px;\n  }\n\n  .chip-value {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
